import { createFileRoute } from '@tanstack/react-router';

import { userPipelineDetailsSearchSchema } from './index.route';

export const Route = createFileRoute(
  '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/',
)({
  validateSearch: userPipelineDetailsSearchSchema,
});
